import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';
import PageOutlet from 'components/pages/PageOutlet';
import useCategorizedPages from 'hooks/app/useCategorizedPages';
import './ReportExercise.css';

const category = 'Exercise';
export default function ReportExercise(props) {
  const {
    renderAll,
    front,
    ...rest
  } = props;

  const pages = useCategorizedPages(category);
  return (
    <PageOutlet
      {...{
        renderAll,
        category,
        pages,
        front,
      }}
    />
  );
}
